// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useJsonApiClient } from '../../contexts/JsonApiContext';
import { useUserState } from '../../contexts/UserContext';

const usePrimaryParty = (): UseQueryResult<string, Error> => {
  const jsonApi = useJsonApiClient();
  const { loggedInUser } = useUserState();

  return useQuery({
    queryKey: ['fetchPrimaryParty', jsonApi, loggedInUser],
    refetchInterval: false, // primary party ID is static
    queryFn: async () => {
      if (!loggedInUser) {
        throw new Error('User is not logged in');
      }

      const userResp = await jsonApi.getV2UsersUserId(loggedInUser.userId);

      if (!userResp.user) {
        throw new Error(`User ${loggedInUser.userId} not found`);
      }
      if (!userResp.user.primaryParty) {
        throw new Error(`User ${loggedInUser.userId} has no primary party`);
      }
      return userResp.user.primaryParty;
    },
  });
};

export default usePrimaryParty;
